module.exports = __webpack_public_path__ + "img/calendar-gear-hover.b0ebad40.svg";